import { jsxs as t, Fragment as x, jsx as r } from "react/jsx-runtime";
import { u as i } from "./index-6a632112.mjs";
import { s as e, r as $, d as s, e as p, a as m } from "./themes-5f0b3c3d.mjs";
import { l as d } from "./lineHeights-72d3110c.mjs";
import { a as h, c as y, b as L } from "./superScript-393c70dc.mjs";
import "react";
import { CloseButton as b } from "./closeButton.js";
import { S as k } from "./checkmarkFilled-c2b01ef1.mjs";
import { S as a } from "./informationFilled-05d57719.mjs";
import { S as c } from "./warningFilled-691cfde1.mjs";
import { h as A } from "./hTag-40b23797.mjs";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
const S = ({ variant: n = "neutral" }) => /* @__PURE__ */ t(x, { children: [
  n === "neutral" && /* @__PURE__ */ r(a, { size: "xs" }),
  n === "information" && /* @__PURE__ */ r(a, { size: "xs" }),
  n === "error" && /* @__PURE__ */ r(c, { size: "xs" }),
  n === "warning" && /* @__PURE__ */ r(c, { size: "xs" }),
  n === "success" && /* @__PURE__ */ r(k, { size: "xs" })
] }), C = () => ` 
  color: inherit;
  font-size: inherit;
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, w = i.div`
  ${h()}
  ${y()}
  ${L()}
  && {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: var(--semantic-spacing-3-x, ${e["3x"]})
      var(--semantic-spacing-4-x, ${e["4x"]});
    gap: var(--semantic-spacing-3-x, ${e["3x"]});
    box-sizing: border-box;
    border-radius: ${$["3x"]};
    ${({ theme: n, $variant: o }) => {
  if (o === "information")
    return {
      backgroundColor: `${n.components.inLineAlert.informationBackground}`,
      color: `${n.components.inLineAlert.informationFontColor}`
    };
  if (o === "neutral")
    return {
      backgroundColor: `${n.components.inLineAlert.neutralBackground}`,
      color: `${n.components.inLineAlert.neutralFontColor}`
    };
  if (o === "warning")
    return {
      backgroundColor: `${n.components.inLineAlert.warningBackground}`,
      color: `${n.components.inLineAlert.warningFontColor}`
    };
  if (o === "error")
    return {
      backgroundColor: `${n.components.inLineAlert.errorBackground}`,
      color: `${n.components.inLineAlert.errorFontColor}`
    };
  if (o === "success")
    return {
      backgroundColor: `${n.components.inLineAlert.successBackground}`,
      color: `${n.components.inLineAlert.successFontColor}`
    };
}}}
  }
`, z = i.div`
  && {
    width: ${e["5x"]};
    height: ${e["5x"]};
    padding-top: ${e["1x"]};
  }
`, F = i.div`
  && {
    font-family: ${s.body};
    font-style: normal;
    width: 100%;
    display: flex;
    height: 100%;
    align-self: center;
    && > div {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
  }
`, B = i(A)`
  && {
    font-family: ${s.body};
    font-weight: ${p.semiBold.L.fontWeight};
    font-size: ${m.medium};
    line-height: ${d.large};
  }
`, W = i.p`
  && {
    ${C()}
    font-family: ${s.body};
    font-weight: ${p.regular.S.fontWeight};
    font-size: ${m.xsmall};
    line-height: ${d.small};
  }
`, X = ({
  variant: n = "neutral",
  titleProp: o,
  body: g,
  onClickClose: l
}) => {
  const u = (f) => {
    switch (f) {
      case "information":
        return "accent";
      case "warning":
        return "orange";
      case "error":
        return "red";
      case "success":
        return "green";
      default:
        return "default";
    }
  };
  return /* @__PURE__ */ t(w, { $variant: n, children: [
    /* @__PURE__ */ r(z, { children: /* @__PURE__ */ r(S, { variant: n }) }),
    /* @__PURE__ */ r(F, { children: /* @__PURE__ */ t("div", { children: [
      o && /* @__PURE__ */ r(B, { as: o.headingLevel || "h1", children: o.title }),
      /* @__PURE__ */ r(W, { children: g })
    ] }) }),
    l && /* @__PURE__ */ r(
      b,
      {
        size: "xsmall",
        onClick: l,
        variant: u(n)
      }
    )
  ] });
};
export {
  X as InLineAlert
};
